import React, { useEffect } from "react";
import "./ProductsServices.css";
import { Link } from "react-router-dom";

const ProductsServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Flights",
      description:
        "Book domestic and international flights with the best deals and seamless booking experience.",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq_BKYbmw4gHbAMVHomDTNWcReI1hkelPeew&s",
      link: "/services/flights",
    },
    {
      title: "Hotels",
      description:
        "Find and book hotels worldwide with exclusive discounts and trusted reviews.",
      img: "https://media.istockphoto.com/id/472899538/photo/downtown-cleveland-hotel-entrance-and-waiting-taxi-cab.jpg?s=612x612&w=0&k=20&c=rz-WSe_6gKfkID6EL9yxCdN_UIMkXUBsr67884j-X9o=",
      link: "/services/hotels",
    },
    {
      title: "Packages",
      description:
        "Explore curated holiday packages that include flights, stays, and activities for a hassle-free vacation.",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZUIWKrXEuWwnVJkKKG2hQyu7Aja-vBqq__g&s",
      link: "/services/packages",
    },
  ];

  return (
    <div className="productsServices-page">
      {/* Hero */}
      <section className="productsServices-hero">
        <div className="hero-overlay">
          <h1>Our Products & Services</h1>
          <p>
            We bring you the best travel solutions for a smooth and memorable
            journey.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="productsServices-content">
        <div className="productsServices-grid">
          {services.map((service, index) => (
            <Link key={index} to={service.link} className="productsServices-card-link">
              <div className="productsServices-card">
                <div className="productsServices-circle">
                  <img src={service.img} alt={service.title} />
                </div>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductsServices;
